import { jsxs as d, jsx as S } from "react/jsx-runtime";
import { forwardRef as K, useMemo as i, cloneElement as y } from "react";
import { c as o } from "./tw-cn-mXgPecoF.mjs";
import { e as L } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { D as M } from "./dot-badge-Cun2K8Z_.mjs";
import { L as w } from "./loop-spinner-B-XwnyQt.mjs";
import { r as H, a as T } from "./rectangle-button.styles-60RjAAV9.mjs";
const k = ["filled_primary", "filled_danger", "transparent"], z = (r) => r === "small" ? "small" : "medium", q = K(
  ({
    theme: r = "filled_primary",
    disabled: p = !1,
    fullWidth: N = !1,
    isCapsule: v = !1,
    showDotBadge: m = !1,
    loading: e = !1,
    size: b,
    weight: x = "bold",
    direction: s = "left",
    disabledType: I = "default",
    ...R
  }, g) => {
    const { children: E, type: P = "button", icon: t, iconVisualCorrectionSpacing: l, className: V, ..._ } = R, a = L({
      property: b,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: { mobile: "medium", pc: "large" }
    }), h = H({ fullWidth: N, ...a, theme: r, weight: x, isCapsule: v, disabledType: I }), c = T({ ...a, direction: s }), n = p || e, $ = i(() => t && s === "left" ? y(t, { className: o(c, e && "opacity-0", t.props.className) }) : null, [t, s, c, e]), B = i(() => t && s === "right" ? y(t, { className: o(c, e && "opacity-0", t.props.className) }) : null, [t, s, c, e]), C = i(() => {
      if (!l) return;
      const j = a.size === "small" ? 8 : 16, u = l + j, D = a.pcSize === "small" ? 8 : 16, f = l + D;
      return s === "left" ? `pr-${u} pc:pr-${f}` : `pl-${u} pc:pl-${f}`;
    }, [s, l, a.size, a.pcSize]);
    return /* @__PURE__ */ d(
      "button",
      {
        "aria-busy": e || void 0,
        "aria-disabled": p || void 0,
        className: o(h, C, e && "relative", V),
        "data-state": e ? "loading" : void 0,
        disabled: n,
        ref: g,
        tabIndex: n ? -1 : 0,
        type: P,
        ..._,
        children: [
          $,
          /* @__PURE__ */ d("span", { className: o("relative flex", !m && "overflow-hidden", e && "opacity-0"), children: [
            E,
            m && !n ? /* @__PURE__ */ S(M, {}) : null
          ] }),
          B,
          e ? /* @__PURE__ */ S(
            w,
            {
              centered: !0,
              color: k.includes(r) ? "inverse" : "primary",
              delay: 0,
              size: { mobile: z(a.size), pc: z(a.pcSize) }
            }
          ) : null
        ]
      }
    );
  }
);
q.displayName = "NDS.RectangleButton";
export {
  q as R
};
